/* ================================================================
   UBIGEO PERU para el formulario de EasySell COD
   Departamento -> Provincia -> Distrito, con datos del INEI.
   Los datos viven en assets/ubigeo-data.js, que DEBE cargarse antes.

   POR QUE ESTE SCRIPT NO TOCA LA PANTALLA
   EasySell esta hecho con Vue: el mantiene su propia copia de que
   opciones existen en cada lista y cual esta elegida. Si uno escribe
   directo en el <select>, Vue no se entera y al enviar el formulario
   sobrescribe la pantalla con su copia interna, que esta vacia. El
   resultado era "This field is required" aunque el cliente hubiera
   elegido. Por eso aqui NO se toca el DOM: se escribe en
   ES_CONFIG.fields, que es la memoria de Vue, y Vue dibuja y valida.

   COMO ESTAN MAPEADOS LOS CAMPOS
     select[name="province"] -> DEPARTAMENTO  (le cargamos 25 opciones)
     select[name="city"]     -> PROVINCIA     (cascada NATIVA de EasySell)
     el personalizado        -> DISTRITO      (lo llenamos nosotros)

   Este reparto no es capricho: EasySell solo sabe encadenar el campo
   "city" y solo contra "province". Ademas ESCONDE el campo city si su
   dependentOptions no tiene entrada para el departamento elegido, y no
   vuelve a aparecer. Por eso city tiene que ser el segundo nivel
   (provincia) y el distrito tiene que ir en el campo personalizado.

   IMPORTANTE: en la app de EasySell el campo "Ciudad" debe llamarse
   "Provincia" y estar ARRIBA del personalizado, que debe llamarse
   "Distrito". Si algun dia se reordenan, las etiquetas quedaran al
   reves aunque el encadenado siga funcionando.
   ================================================================ */
(function () {
  'use strict';

  var RAW = window.UBIGEO_RAW || '';
  if (!RAW) {
    console.warn('[ubigeo] Faltan los datos: ubigeo-data.js debe cargar antes que este archivo.');
    return;
  }

  /* Erratas de la base publica del INEI que usamos como fuente. */
  var ERRATAS = {
    'La Uniòn': 'La Unión',
    'Pàucar del Sara Sara': 'Páucar del Sara Sara',
    'Omachaç': 'Omacha',
    'Anco_Huallo': 'Anco Huallo'
  };
  function corregir(n) { return ERRATAS[n] || n; }

  /* Formato compacto: ~ separa departamentos, | separa provincias,
     cada provincia es "Nombre:distrito,distrito,..." */
  var PE = {};
  RAW.split('~').forEach(function (bloque) {
    var p = bloque.split('|');
    var dep = corregir(p[0]);
    PE[dep] = {};
    for (var i = 1; i < p.length; i++) {
      var c = p[i].indexOf(':');
      PE[dep][corregir(p[i].slice(0, c))] = p[i].slice(c + 1).split(',').map(corregir);
    }
  });

  function noMark(c) { var k = c.charCodeAt(0); return k < 768 || k > 879; }
  function norm(s) {
    return (s || '').toString()
      .normalize('NFD').split('').filter(noMark).join('')
      .toLowerCase().trim();
  }

  var distritosPorProvincia = {};   /* value de provincia -> [distritos] */
  var yaEscuchando = false;

  function campos() {
    var f = window.ES_CONFIG && window.ES_CONFIG.fields;
    if (!f || !f.length) return null;
    var dep = null, pro = null, dis = null;
    f.forEach(function (x) {
      if (x.value === 'province') dep = x;
      else if (x.value === 'city') pro = x;
      else if (x.type === 'select' && /^select\d+$/.test(x.value || '')) dis = x;
    });
    return (dep && pro) ? { dep: dep, pro: pro, dis: dis } : null;
  }

  function aplicar() {
    var app = window.easysellApp;
    if (!app || !app.$set) return false;
    var c = campos();
    if (!c) return false;
    if (c.dep.__ubigeo) return true;          /* ya configurado */
    if (!c.dep.options || !c.dep.options.length) return false;

    /* Reutilizamos los value/code originales de Shopify (PE_PE-ARE...)
       para que la direccion del pedido siga siendo valida. */
    var previas = c.dep.options.slice();
    function original(nombre) {
      var n = norm(nombre);
      var exacta = null, prefijo = null;
      previas.forEach(function (o) {
        var l = norm(o.label);
        if (!exacta && l === n) exacta = o;
        if (!prefijo && l.indexOf(n) === 0) prefijo = o;
      });
      return exacta || prefijo;
    }

    var deps = Object.keys(PE).sort(function (a, b) { return a.localeCompare(b, 'es'); })
      .map(function (nombre) {
        var o = original(nombre);
        return { label: nombre, value: o ? o.value : 'PE_' + nombre, code: o ? o.code : nombre };
      });

    var provinciasPorDepartamento = {};
    distritosPorProvincia = {};
    deps.forEach(function (d) {
      provinciasPorDepartamento[d.value] = Object.keys(PE[d.label]).map(function (p) {
        var pv = d.code + '_' + p;
        distritosPorProvincia[pv] = PE[d.label][p];
        return { label: p, value: pv };
      });
    });

    app.$set(c.dep, 'options', deps);
    app.$set(c.pro, 'dependentOptions', provinciasPorDepartamento);
    c.dep.__ubigeo = true;

    if (!yaEscuchando) {
      /* Provincia -> Distrito. En captura, para adelantarnos a Vue, y con
         un respiro para que Vue termine su propio ciclo antes de escribir. */
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.tagName !== 'SELECT' || t.name !== 'city') return;
        var cc = campos();
        if (!cc || !cc.dis) return;
        var lista = (distritosPorProvincia[t.value] || []).map(function (x) {
          return { label: x, value: t.value + '_' + x };
        });
        setTimeout(function () { window.easysellApp.$set(cc.dis, 'options', lista); }, 60);
      }, true);
      yaEscuchando = true;
    }
    return true;
  }

  /* El formulario se crea al hacer clic en el boton, y EasySell puede
     rehacer su configuracion. Reintentamos hasta lograrlo y seguimos
     vigilando por si vuelve a montarse. */
  aplicar();
  setInterval(aplicar, 700);
})();
